import { useFormStore } from '@/stores/form'
import useFormatDate from '@/composables/useFormatDate'
import { useAuthStore } from '@/stores/auth'

export default function () {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const res = {
    __isLoggedIn__: !authStore.isGuestUser,
    refundableAmount: formStore.form.values.refundableAmount,
    referenceRequestNumber: formStore.form.values.referenceRequestNumber,
    referenceRequestNumber_length: formStore.form.values.referenceRequestNumber?.length,
    refundMethodId: formStore.form.values.refundMethodId,
    allowedRefundMethodIds:
      formStore.form.values.refundableAmount?.[0]?.allowedRefundMethodIds?.length > 0,
    othersBeneficiaryType: formStore.form.values.othersBeneficiaryType,
    useFileNumber: formStore.form.values.useFileNumber,
    isTypingCenter: authStore.isUserTypingCenter,
    isUserEstablishment: authStore.isUserEstablishment
  }
  return res
}
